"use strict";
// Zoom
const mainImage = document.getElementById("product-main-image");
if (mainImage) {
    var x = 0, y = 0, width = 0, height = 0;
    mainImage.onmouseover = (event) => {
        let size = mainImage?.getBoundingClientRect();
        if (size) {
            x = size.x;
            y = size.y;
            width = size.width;
            height = size.height;
        }
    };
    mainImage.onmousemove = (event) => {
        // Calculate horizontal and vertical percentages
        let horizontal = ((event.clientX - x) / width) * 100;
        let vertical = ((event.clientY - y) / height) * 100;
        mainImage.style.setProperty("--x", horizontal + "%");
        mainImage.style.setProperty("--y", vertical + "%");
    };
}
// Popup function
function AddedToCartPop() {
    const popP = document.getElementById("popup-add");
    if (!popP)
        return;
    const pop = document.createElement("span");
    pop.textContent = popP.getAttribute("data-text");
    popP.appendChild(pop);
    setTimeout(() => {
        pop.style.top = "1.5rem";
    }, 100);
    setTimeout(() => {
        pop.style.opacity = "0";
    }, 2000);
    setTimeout(() => {
        pop.remove();
    }, 2500);
}
// Image Change
const allImages = document.querySelectorAll(".product-image-selector-slot");
allImages.forEach((elem) => {
    elem.addEventListener("click", (event) => {
        var elemImg = elem.querySelector("img");
        if (elemImg) {
            mainImage?.querySelector("img")?.setAttribute("src", elemImg.getAttribute("src"));
            mainImage?.querySelector("img")?.removeAttribute("srcset");
            mainImage?.querySelector("img")?.setAttribute("srcset", elemImg.getAttribute("data-srcset"));
        }
    });
});
// Quantity
var quantity = 1;
const quantityDecrease = document.querySelectorAll("#quantity-decrease");
const quantityIncrease = document.querySelectorAll("#quantity-increase");
const quantityMain = document.querySelector("#quantity-main");
if (quantityMain) {
    quantityDecrease.forEach((element) => {
        element.addEventListener("click", (event) => {
            let value = parseInt(quantityMain.value);
            if (Number.isNaN(value)) {
                value = parseInt(quantityMain.min);
            }
            value = Math.max(value - 1, parseInt(quantityMain.min));
            quantity = value;
            quantityMain.value = value.toString();
        });
    });
    quantityIncrease.forEach((element) => {
        element.addEventListener("click", (event) => {
            let value = parseInt(quantityMain.value);
            if (Number.isNaN(value)) {
                value = parseInt(quantityMain.min);
            }
            value = value + 1;
            quantity = value;
            quantityMain.value = value.toString();
        });
    });
}
// Variant + Adding To Cart
document.querySelectorAll(".js-product-update-select").forEach((elem) => {
    elem.addEventListener("change", (event) => {
        UpdateProductInfo();
    });
});
var firstRefresh = true;
function UpdateProductInfo() {
    var selects = document.querySelectorAll(".js-product-update-select");
    let option = "";
    // Make Variant String
    selects.forEach((elem) => {
        if (firstRefresh === true) {
            // Always Oversize
            if (elem.getAttribute("name") === "Krój koszulki" || elem.getAttribute("name") === "Type") {
                if (Array.from(elem.querySelectorAll("option")).some((option) => option.value === "Oversize")) {
                    elem.value = "Oversize";
                }
            }
            // Always M
            if (elem.getAttribute("name") === "Rozmiar" || elem.getAttribute("name") === "Size") {
                if (Array.from(elem.querySelectorAll("option")).some((option) => option.value === "M")) {
                    elem.value = "M";
                }
            }
        }
        if (option === "")
            option = `${elem.value}`;
        else
            option = `${option} / ${elem.value}`;
    });
    firstRefresh = false;
    if (option === "Standard / XXL") {
        option = "Standard / XL";
        selects.forEach((elem) => {
            if (elem.value === "XXL") {
                elem.value = "XL";
            }
        });
    }
    else if (option === "Oversize / XS") {
        option = "Oversize / S";
        selects.forEach((elem) => {
            if (elem.value === "XS") {
                elem.value = "S";
            }
        });
    }
    // Option
    var optionsSelect = document.querySelector("#product-main-variant");
    var optionsValue = optionsSelect?.querySelectorAll("option");
    var selectedOption;
    optionsValue?.forEach((elem) => {
        if (elem.label === option) {
            selectedOption = elem;
        }
    });
    if (optionsSelect && selectedOption) {
        optionsSelect.value = selectedOption.value;
        UpdateInfoForCurrentlySelectedItem();
    }
}
function UpdateInfoForCurrentlySelectedItem() {
    const itemHandle = document.querySelector("[data-handle]")?.getAttribute("data-handle");
    const originalPrice = document.querySelector("[data-original-price]")?.getAttribute("data-original-price");
    const buyButton = document.querySelector("#add-to-cart");
    const sold_out = document.querySelector("#sold-out");
    if (buyButton) {
        buyButton.classList.add("hidden");
    }
    if (sold_out) {
        sold_out.classList.remove("hidden");
    }
    axios.get(`/products/${itemHandle}.js`).then((res) => {
        var currentVariant = document.querySelector("#product-main-variant");
        // Getting Data of the current variant
        var variants = res.data.variants;
        var selectedVariant = variants.find((item) => item.id === parseInt(currentVariant.value));
        // Updating visibility of the buy buttons
        if (selectedVariant != null) {
            if (buyButton) {
                if (selectedVariant.available === true) {
                    buyButton.classList.remove("hidden");
                }
                else {
                    buyButton.classList.add("hidden");
                }
            }
            if (sold_out) {
                if (selectedVariant.available === true) {
                    sold_out.classList.add("hidden");
                }
                else {
                    sold_out.classList.remove("hidden");
                }
            }
        }
        // Updating Price
        if (selectedVariant != null) {
            var prices = document.querySelectorAll(".js-price");
            prices.forEach((elem) => {
                // Ignoring price update on the variant
                if (elem.classList.contains("ignore-price-update"))
                    return;
                elem.setAttribute("data-price", selectedVariant.price);
              
            });
            window.kingslayer.updateCurrenciesDisplay(originalPrice);
        }
    });
}
var addButtons = document.querySelectorAll("#add-to-cart");
addButtons.forEach((element) => {
    element.addEventListener("click", (event) => {
        AddToCart();
    });
});
function AddToCart() {
    var variantSelector = document.querySelector("#product-main-variant");
    var variantId = variantSelector?.value;
    axios
        .post("/cart/add.js", {
        id: variantId,
        quantity: quantity,
    })
        .then((res) => {
        axios.get("/cart.js").then((res) => {
            AddedToCartPop();
            var headerCart = document.querySelector(".header-cart-badge");
            if (headerCart) {
                if (res.data.item_count > 0) {
                    headerCart.textContent = res.data.item_count.toString();
                    headerCart.classList.remove("cart-empty");
                }
                else {
                    headerCart.textContent = "0";
                    headerCart.classList.add("cart-empty");
                }
            }
        });
    });
}
UpdateProductInfo();
